import { AlertCircle, CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import formStyles from '@/features/application/styles/editForm.module.css'
import styles from '../styles/modelAdd.module.css'

export interface ModelFileFieldProps {
  id: string
  label: string
  labelNote: string
  accept: string
  required?: boolean
  currentFileLabel?: string | null
  error?: string | null
  onChange: (file: File | null) => void
}

/** Angular `pkl-file-field` — label note + current file status inline on the label row. */
export function ModelFileField({
  id,
  label,
  labelNote,
  accept,
  required = false,
  currentFileLabel,
  error,
  onChange,
}: ModelFileFieldProps) {
  return (
    <div className={cn(formStyles.formGroup, styles.formGroupFull)}>
      <label htmlFor={id} className={styles.fieldLabel}>
        {label}
        {required ? <span className={formStyles.required}>*</span> : null}{' '}
        <span className={styles.labelNote}>{labelNote}</span>
        {currentFileLabel ? (
          <span className={styles.pklFileStatus}>
            <CheckCircle2 size={14} className={styles.pklFileStatusIcon} aria-hidden />
            Current file: {currentFileLabel}
          </span>
        ) : null}
      </label>
      <input
        id={id}
        type="file"
        accept={accept}
        className={cn(formStyles.input, styles.fileControl)}
        onChange={(event) => onChange(event.target.files?.[0] ?? null)}
      />
      {error ? (
        <div className={styles.fieldError}>
          <AlertCircle size={16} aria-hidden />
          {error}
        </div>
      ) : null}
    </div>
  )
}
